import { Outlet } from "react-router-dom";
import OrganizationList from "./OrganizationsList/OrganizationList";
import OrgForm from "pages/Admin/Orgs/OrgForm";
import { OrgModules } from "./OrgModules";

export const organizationsRoutes = [
  {
    path: "organizations",
    element: Outlet,
    children: [
      {
        path: "",
        element: OrganizationList,
      },
      {
        path: "add",
        element: OrgForm,
      },
      {
        path: "edit/:id",
        element: OrgForm,
      },
      {
        path: "modules/:id",
        element: OrgModules,
      },
    ],
  },
];
